import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsAdminRefferalPending_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsAdminRefferalPending_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  KuikaB2B_OrderSalesCustomerMobile: any[];
  KuikaB2B_OrderSalesCustomerMobile_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp586092Visible: "visible" | "hidden";
}

export class ReportsAdminRefferalPending_ScreenBase extends React.PureComponent<
  IReportsAdminRefferalPending_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  reportsadminrefferalpending_186190_value_kuikaSelectBoxRef: React.RefObject<any>;
  reportsadminrefferalpending_582395_value_kuikaDateRef: React.RefObject<any>;
  reportsadminrefferalpending_290230_value_kuikaDateRef: React.RefObject<any>;
  reportsadminrefferalpending_189683_value_kuikaTableRef: React.RefObject<any>;
  reportsadminrefferalpending_842507_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 49696,
          PropertyName: "value",
          Value: "Bekleyen Sipariş Raporu",
          TagName: "Label16_value",
        },
        {
          Id: 360654,
          PropertyName: "value",
          Value: "Bekleyen Siparişler",
          TagName: "Label3_value",
        },
        {
          Id: 48157,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 731063,
          PropertyName: "value",
          Value: "Filtre",
          TagName: "Label1_value",
        },
        {
          Id: 551086,
          PropertyName: "value",
          Value: "Tarih Filtresi",
          TagName: "Label6_value",
        },
        {
          Id: 186190,
          PropertyName: "placeholder",
          Value: "Tarih Aralığı",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 582395,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 290230,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 375979,
          PropertyName: "label",
          Value: "Temizle",
          TagName: "Button2_label",
        },
        {
          Id: 871103,
          PropertyName: "label",
          Value: "Uygula",
          TagName: "Button1_label",
        },
        {
          Id: 533520,
          PropertyName: "value",
          Value: "Müşteri Kodu",
          TagName: "Label29_value",
        },
        {
          Id: 822570,
          PropertyName: "value",
          Value: "Müşteri Ünvan",
          TagName: "Label31_value",
        },
        {
          Id: 118896,
          PropertyName: "value",
          Value: "Miktar",
          TagName: "Label33_value",
        },
        {
          Id: 818510,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label35_value",
        },
        {
          Id: 43566,
          PropertyName: "value",
          Value: "Sevk Bekleyen Mkt.",
          TagName: "Label37_value",
        },
        {
          Id: 165829,
          PropertyName: "value",
          Value: "Sevk Bekleyen Mr.",
          TagName: "Label39_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 49696,
          PropertyName: "value",
          Value: "Pending Order Report",
          TagName: "Label16_value",
        },
        {
          Id: 360654,
          PropertyName: "value",
          Value: "Pending Orders",
          TagName: "Label3_value",
        },
        {
          Id: 48157,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 731063,
          PropertyName: "value",
          Value: "Filter",
          TagName: "Label1_value",
        },
        {
          Id: 551086,
          PropertyName: "value",
          Value: " Date Filter",
          TagName: "Label6_value",
        },
        {
          Id: 186190,
          PropertyName: "placeholder",
          Value: "Date Range",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 582395,
          PropertyName: "placeholder",
          Value: "Start Date...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 290230,
          PropertyName: "placeholder",
          Value: "End Date...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 375979,
          PropertyName: "label",
          Value: "Clear",
          TagName: "Button2_label",
        },
        {
          Id: 871103,
          PropertyName: "label",
          Value: "Apply",
          TagName: "Button1_label",
        },
        {
          Id: 533520,
          PropertyName: "value",
          Value: "Customer Code",
          TagName: "Label29_value",
        },
        {
          Id: 822570,
          PropertyName: "value",
          Value: "Customer Title",
          TagName: "Label31_value",
        },
        {
          Id: 118896,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label33_value",
        },
        {
          Id: 818510,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label35_value",
        },
        {
          Id: 43566,
          PropertyName: "value",
          Value: "Quantities Pending Shipment.",
          TagName: "Label37_value",
        },
        {
          Id: 165829,
          PropertyName: "value",
          Value: "Mr. Pending Referral",
          TagName: "Label39_value",
        },
        {
          Id: 15108472,
          PropertyName: "8e508137-684a-db5f-00a3-4ebf8a00c24b_notify",
          Value: "Report Successfully Generated",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cb5ea49c-2242-4da8-84b9-ccbf70511ad5",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 49696, PropertyName: "value", Value: "Bekleyen Sipariş Raporu" },
        { Id: 731063, PropertyName: "value", Value: "Filtre" },
        { Id: 551086, PropertyName: "value", Value: "Tarih Filtresi" },
        { Id: 186190, PropertyName: "placeholder", Value: "Tarih Aralığı" },
        {
          Id: 582395,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
        },
        { Id: 290230, PropertyName: "placeholder", Value: "Bitiş Tarihi..." },
        { Id: 375979, PropertyName: "label", Value: "Temizle" },
        { Id: 871103, PropertyName: "label", Value: "Uygula" },
        { Id: 360654, PropertyName: "value", Value: "Bekleyen Siparişler" },
        { Id: 48157, PropertyName: "label", Value: "Export" },
        { Id: 352384, PropertyName: "title", Value: "Title" },
        { Id: 533520, PropertyName: "value", Value: "Müşteri Kodu" },
        {
          Id: 329133,
          PropertyName: "value",
          Value: "[datafield:customercode]",
        },
        { Id: 822570, PropertyName: "value", Value: "Müşteri Ünvan" },
        {
          Id: 744749,
          PropertyName: "value",
          Value: "[datafield:customerdescription]",
        },
        { Id: 118896, PropertyName: "value", Value: "Miktar" },
        { Id: 142406, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 818510, PropertyName: "value", Value: "Metrekare" },
        { Id: 704692, PropertyName: "value", Value: "[datafield:qty2]" },
        { Id: 43566, PropertyName: "value", Value: "Sevk Bekleyen Mkt." },
        {
          Id: 365083,
          PropertyName: "value",
          Value: "[datafield:remainingorderqty1]",
        },
        { Id: 165829, PropertyName: "value", Value: "Sevk Bekleyen Mr." },
        {
          Id: 849887,
          PropertyName: "value",
          Value: "[datafield:remainingorderqty2]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.reportsadminrefferalpending_186190_value_kuikaSelectBoxRef =
      React.createRef();
    this.reportsadminrefferalpending_582395_value_kuikaDateRef =
      React.createRef();
    this.reportsadminrefferalpending_290230_value_kuikaDateRef =
      React.createRef();
    this.reportsadminrefferalpending_189683_value_kuikaTableRef =
      React.createRef();
    this.reportsadminrefferalpending_842507_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      KuikaB2B_OrderSalesCustomerMobile: [],
      SetValueOf: "",
      Notify: false,
      NAVIGATE: "",
      dataSource_186190: [
        { key: "10", text: "İki Tarih Arası Filtreleme" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp586092Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportsadminrefferalpending",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsAdminRefferalPendingPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsAdminRefferalPendingPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsadminrefferalpending",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsadminrefferalpending",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsAdminRefferalPendingPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsAdminRefferalPendingPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsAdminRefferalPendingPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferalPending/ReportsAdminRefferalPendingPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerMobile =
      result?.data.kuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ReportsAdminRefferalPendingPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp586092Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_189683 =
      stateVars.KuikaB2B_OrderSalesCustomerMobile ??
      this.state.KuikaB2B_OrderSalesCustomerMobile;
    formVars.reportsadminrefferalpending_842507_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_494665_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_186190_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ReportsAdminRefferalPending/ReportsAdminRefferalPendingComponent_186190_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.KuikaB2B_OrderSalesCustomerMobile =
        result?.data.kuikaB2B_OrderSalesCustomerMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingComponent_186190_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingComponent_186190_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingComponent_186190_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferalpending_842507_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.isComp586092Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalPendingComponent_186190_onChange2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingComponent_186190_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingComponent_186190_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingComponent_186190_onChange3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingComponent_186190_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.dataSource_189683 =
        stateVars.KuikaB2B_OrderSalesCustomerMobile ??
        this.state.KuikaB2B_OrderSalesCustomerMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingComponent_186190_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingComponent_186190_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingComponent_186190_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.reportsadminrefferalpending_842507_total =
        ReactSystemFunctions.value(
          this,
          stateVars.KuikaB2B_OrderSalesCustomerMobile !== undefined
            ? stateVars.KuikaB2B_OrderSalesCustomerMobile?.length > 0
              ? stateVars.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
              : null
            : this.state.KuikaB2B_OrderSalesCustomerMobile?.length > 0
            ? this.state.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
            : null
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_375979_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferalpending_582395_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferalpending_290230_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_871103_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferalPending/ReportsAdminRefferalPendingComponent_871103_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerMobile =
      result?.data.kuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalPendingComponent_871103_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingComponent_871103_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferalpending_842507_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_189683 =
      stateVars.KuikaB2B_OrderSalesCustomerMobile ??
      this.state.KuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_48157_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8e508137_684a_db5f_00a3_4ebf8a00c24b_notify",
        this.defaultML,
        "Rapor Başarıyla Oluşturuldu"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_797101_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/reportsadminrefferalpendingheader") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ReportsAdminRefferalPendingHeader",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "reportsadminrefferalpending_189683_value",
          "customerCode"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ReportsAdminRefferalPending",
      "ReportsAdminRefferalPendingHeader",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingComponent_842507_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_186190_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_582395_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_290230_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferalpending_842507_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferalPending/ReportsAdminRefferalPendingComponent_842507_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerMobile =
      result?.data.kuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalPendingComponent_842507_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingComponent_842507_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_189683 =
      stateVars.KuikaB2B_OrderSalesCustomerMobile ??
      this.state.KuikaB2B_OrderSalesCustomerMobile;
    formVars.reportsadminrefferalpending_842507_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsAdminRefferalPendingPageInit();
    }
  }
}
